import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute ({ element }) {
    const token = localStorage.getItem('authToken');

    if (!token) {
        // If no token, redirect to login
        return <Navigate to="/signin" />;
    }

    // If token exists, render the element
    return element;
};

export default ProtectedRoute; 